$(document).ready(function(){
  if($(window).width() <= 768){ 
    $('.contact-slide').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      useTransform: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            swipe: true,
            dots: true,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            swipe: true,
            dots: true,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: true,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});